/**
 * Stable CSS class names for E2E — OTP Password page.
 */
export const OTPP = {
    page: 'otp-password-page',
    layout: 'otp-password-page__layout',
    breadcrumbSection: 'otp-password-page__breadcrumb-section',

    emptyState: 'otp-password-page__empty-state',
    emptyNoRecord: 'otp-password-page__empty-no-record',
    filterFormControl: 'otp-password-page__filter-form-control',
    filterInputLabel: 'otp-password-page-input__label--country',
    filterSelect: 'otp-password-page-input--select-country',
    filterMenuItem: 'otp-password-page-input--menu-item-country',
    filterMenuItemFlagImg: 'otp-password-page__country-flag-img',
    filterMenuItemText: 'otp-password-page__country-text',
    filterButton: 'otp-password-page-input--button-filter',

    tabsSection: 'otp-password-page__tabs-section',
    tabs: 'otp-password-page__tabs',
    tab: 'otp-password-page__tab',
    tabLabel: 'otp-password-page__tab-label',
    tabPanel: 'otp-password-page__tab-panel',
} as const;

export const otppCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

